import { ApplicantInformation_Handle } from './action';
const initState = {
};

const reducer = (state = initState, action) => {
    switch (action.type) {
        case ApplicantInformation_Handle: 
            return {
                ...state,
                ...action.data
            };
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/views/ApplicantInformation/state/reducer.js